import { useState } from "react";
import { useAppContext } from "../../../context";

export const CartPageInfo = ({cart = [], updateCart, cartTotal, navigate,toast}) => {
  const { formatPrice } = useAppContext();

  const delivery = cartTotal>30?0:3.99;
  const tax = cartTotal*.1;
  const total = cartTotal+delivery+tax;
  const [promo, setPromo] = useState("");

  if (!cart.length) return (
    <div className="max-w-lg mx-auto px-4 py-28 text-center">
      <div className="text-8xl mb-6 aflt">🛒</div>
      <h2 className="font-serif text-3xl text-gray-900 mb-3">Your cart is empty</h2>
      <p className="text-gray-400 mb-8">Add some delicious food to get started!</p>
      <button onClick={() => navigate("menu")} className="bg-[#f97316] text-white font-black px-8 py-4 rounded-2xl hover:bg-orange-600 btn-press">Browse Menu 🍽️</button>
    </div>
  );

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="font-serif text-4xl text-gray-900 mb-8">Your <span className="text-[#f97316]">Cart</span></h1>
      <div className="grid md:grid-cols-3 gap-8">
        <div className="md:col-span-2 space-y-3">
          {cart.map(item => (
            <div key={item.id} className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm flex gap-4 items-center card-hover">
              <img src={item.img} alt={item.name} className="w-20 h-20 rounded-xl object-cover flex-shrink-0"/>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                 <div className={`w-4 h-4 rounded border-2 flex items-center justify-center ${item.veg ? "border-green-500" : "border-red-500"}`}>
                   <div className={`w-2 h-2 rounded-full ${item.veg ? "bg-green-500" : "bg-red-500"}`}/>
                 </div>
                <h3 className="font-bold text-gray-900 truncate">{item.name}</h3></div>
                <p className="text-xs text-gray-400 lc2 mb-1">{item.desc}</p>
                <span className="font-black text-[#f97316] text-lg">{formatPrice(item.price)}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <button onClick={() => updateCart(item.id, item.qty-1)} className="w-8 h-8 rounded-xl bg-gray-100 font-black hover:bg-red-100 transition-colors">−</button>
                <span className="w-8 text-center font-black">{item.qty}</span>
                <button onClick={() => updateCart(item.id, item.qty+1)} className="w-8 h-8 rounded-xl bg-gray-100 font-black hover:bg-green-100 transition-colors">+</button>
              </div>
              <span className="font-black text-gray-800 w-16 text-right flex-shrink-0">{formatPrice(item.price*item.qty)}</span>
              <button onClick={() => updateCart(item.id,0)} className="text-gray-200 hover:text-red-400 transition-colors flex-shrink-0 ml-1">🗑️</button>
            </div>
          ))}
        </div>

        <div className="space-y-4">
          <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm">
            <h3 className="font-bold text-gray-900 mb-4 text-base">Order Summary</h3>
            {cartTotal < 30 && (
              <div className="mb-4">
                <div className="flex items-center justify-between text-xs mb-1.5"><span className="text-gray-500">Add {formatPrice(30-cartTotal)} for free delivery</span><span className="text-[#f97316] font-bold">{Math.round((cartTotal/30)*100)}%</span></div>
                <div className="h-2 bg-gray-100 rounded-full overflow-hidden"><div className="h-full bg-gradient-to-r from-[#f97316] to-red-500 rounded-full transition-all" style={{width:`${Math.min((cartTotal/30)*100,100)}%`}}/></div>
              </div>
            )}
            <div className="space-y-2 text-sm mb-4">
              <div className="flex justify-between text-gray-500"><span>Subtotal</span><span className="font-semibold">{formatPrice(cartTotal)}</span></div>
              <div className="flex justify-between text-gray-500"><span>Delivery</span><span className={`font-semibold ${delivery===0?"text-green-500":""}`}>{delivery===0?"FREE":formatPrice(delivery)}</span></div>
              <div className="flex justify-between text-gray-500"><span>Tax (10%)</span><span className="font-semibold">{formatPrice(tax)}</span></div>
              <div className="flex justify-between font-black text-gray-900 text-base border-t border-gray-100 pt-2.5 mt-2.5"><span>Total</span><span className="text-[#f97316]">{formatPrice(total)}</span></div>
            </div>
            <div className="flex gap-2 mb-4">
              <input value={promo} onChange={e=>setPromo(e.target.value)} placeholder="Promo code" className="flex-1 px-3 py-2.5 border border-gray-200 rounded-xl text-sm bg-white"/>
              <button onClick={() => toast(promo?"Invalid promo code":"Enter a promo code","error")} className="bg-gray-100 text-gray-700 font-bold px-4 py-2.5 rounded-xl text-sm hover:bg-orange-100 transition-colors btn-press">Apply</button>
            </div>
            <button onClick={() => navigate("checkout")} className="w-full bg-gradient-to-r from-[#f97316] to-red-500 text-white font-black py-4 rounded-2xl hover:shadow-xl hover:shadow-orange-200 transition-all btn-press">
              Proceed to Checkout →
            </button>
          </div>
          <div className="bg-orange-50 rounded-2xl p-4 flex items-center gap-3 border border-orange-100">
            <span className="text-2xl">🛡️</span>
            <div><p className="text-sm font-bold text-gray-800">Secure Checkout</p><p className="text-xs text-gray-500">256-bit SSL · PCI DSS compliant</p></div>
          </div>
        </div>
      </div>
    </div>
  );
};
